module.exports={
    btn:{
        tips_reelect_btn:"Új kép",
        cancel_btn:"Megszünteti",
        tips_continue_dispose:"Előkelő támogatott képek",
        tips_return:"Új kép",
        tips_upgrade:"Frissítés",
        tips_yes:"rendben",
        delete:"Töröl",
        download:"Letöltés",
        upload_image:"Kép feltöltése",
        new_image:"Új kép",
        save_all:"Összes mentése",
        cancel:"Törlés",
        save:"Megment",
        view_comparison:"Összehasonlítás megtekintése",
        hide_comparison:"Összehasonlítás elrejtése",
        previous:"Előző",
        next:"Következő",
        continue_download:"Képek mentése vízjelekkel",
        present:"Alkalmazás erre a képre",
        all_wait:"Alkalmazás a Várakozás alatt lévő képekre",
        all:"Alkalmazás az összes képre",
        history:"Történelem",
        login:"Belépés",
    },
    tips:{
        please_upgrade:"Jelenlegi csomagja nem támogatja a képek kötegelt feltöltését vagy felnagyítását. Kérjük, frissítse, hogy több előnyben részesüljön.",
        errorlistinfo:"XXX kép van kiválasztva. XXX kép támogatott, de XXX kép nem támogatott. A következő képek nem támogatottak:",
        max:"Haladja túl a maximális 10 MB-os képméretet!",
        max_size:"Túllépje a maximális képoldalhossz-korlátot, 4096px!",
        continue_dispose:"Előkelő támogatott képek",
        please_multiple:"Kérjük, válassza ki a nagyítást.",
        max_multiple:"* A kép legfeljebb 4K-ra lesz nagyítva (a leghosszabb oldal nem haladhatja meg a 4096 képpontot).",
        title:"Név",
        reasons:"Okok",
        upload_type:"Nem támogatott",
        used_up:"A vízjel nélkül mentett HD-képek száma elfogyott. Kérjük, frissítse fiókját. Vagy menthet HD képeket vízjelekkel.",
        edit_multiple:"Több kép is van feltöltve. Kérjük, válassza ki azokat a képeket, amelyeknél módosítani szeretné a nagyítást. A kiválasztás után ezek a képek ismét fel lesznek méretezve az új nagyításra.",
        download_confirm:"Néhány kép feldolgozása még folyamatban van. Biztosan menti az összes felskálázott képet? Ha ugyanazt a képet ismételten menti, a mentett képek száma nem kerül levonásra.",
        waiting_save:"Néhány kép feldolgozása még folyamatban van. Kérjük, mentse el később.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD kép(ek)",
        watermarks:"vízjel nélkül jelenleg letölthető.",
        view_details:"Részletek megtekintése",
        loading:"Betöltés…",
    },
    content:{
        failed:"nem sikerült",
        completed:"Befejezve",
        processing:"Feldolgozás",
        img_processing:"Feldolgozás…",
        img_failed:"Nem sikerült feldolgozni",
        uploading:"Feltöltés",
        img_uploading:"Feltöltés…",
        wait_upoading:"Várakozás a feltöltésre…",
        waiting:"Várakozás",
        img_waiting:"Várakozás…",
        empty:"Üres",
        magnification:"Nagyítás:",
        drop:"Vagy dobja ide a képfájlt, hogy feljavítsa és javítsa!",
        original:"Eredeti:",
        output:"Kimenet:",
        img_rendering1:"Kuvaasi on paranneltu.",
        img_rendering2:"Työskentelemme korkealaatuisen kuvan renderöimiseksi esikatselua varten, odota...",
        no_watermark:"Tallennuksen jälkeen kuvassa ei ole vesileimaa.",
    },
    banner_msg:"Válasszon egy tervet az Image Upscalerhez",
    monthly:"HAVI",
    lifetime:"ÉLETTARTAM",
    choose_plan:"Válassza ki tervét a képek száma alapján",
    return_home:"Gratulálunk! Sikeresen frissítetted. Kérjük, térjen vissza a kezdőlapra, és használja ezt a terméket.",
    congratulations:"Gratulálunk! Sikeresen frissítetted. Az előnyök a frissítés során megadott e-mail címhez lettek kötve. Kérjük, használja a regisztrált vagy az e-mail címhez kapcsolódó fiókot",
    login_benefits:"jelentkezzen be az előnyök használatához",
    no_registered:". Ha még nem regisztrált vagy nem kapcsolt fiókot az e-mail címmel, kérjük",
    register_account:"használja az e-mail címet a fiók regisztrálásához",
    other_accounts:" vagy kapcsoljon más fiókokat ehhez az e-mail címhez az előnyök igénybevételéhez.",
    btn_close:"Bezárás",
    free:"Ingyenes",
    btn_get_started:"Fogj neki",
    // access_to:"Hozzáférés",
    upscale_images:"Előkelő képek",
    up_to:"Akár",
    per_image:" képenként",
    resolution_of:"Felbontásáig",
    default_level:"Előkelő képek alapértelmezett szinten",
    image_downloads:"2 HD kép letöltése vízjel nélkül",
    unlimited_image:"Korlátlan számú képletöltés vízjellel",
    SHA256_encryption:"SHA256 titkosítási technika",
    mon:"Havi",
    images:"képeket",
    high_resolution:" nagy felbontású minőséggel",
    tax_incl:"Adóval együtt",
    image:"kép",
    secure_checkout:"Biztonságos fizetés",
    everything:"Minden az Ingyenes és",
    upscaling_levels:"Az összes felskálázási szint kiválasztható",
    unlimited_image_without:"Korlátlan számú képletöltés vízjel nélkül",
    viewable_editing:"A látható szerkesztési előzmények érvényesek",
    days:" napok",
    high_level:"Magas szint",
    priority_processing:" elsőbbségi feldolgozás",
    left:"Élettartam",
    resolution:" felbontás",


    "history_will":"után lejár",
    "history.days":"Napok)",
    "history.hours":"órák",
    "expired":"Lejárt",
    "access_to":"Az ingyenes próbaverzióval csak",
    "pricing.upload_images":"Képek feltöltése",
    "pricing.under":"alatt",
    "pricing.images":"képeket",
    "pricing.without_watermark":"vízjel nélkül",
    "pricing.process_images":"Képek feldolgozása legfeljebb",
    "pricing.pixels":"pixel",
    "pricing.enjoy_limited":"Élvezze a korlátozott előkelő osztályzatokat",
    "pricing.download":"Letöltés",
    "pricing.HD_images":"HD képek vízjel nélkül",
    "pricing.and_you":"És szenvedhetsz tőle",
    "pricing.slow_upscaling":"lassú felskálázás",
    "pricing.lower_priority":"alacsonyabb prioritású",
    "pricing.without":"vízjel nélkül",
    "pricing.tax":"Az eladási ár tartalmazza az adót, és az Ön országa és régiója alapján automatikusan kiszámításra kerül. A kosárban láthatja a részletes adó összegét. A végső fizetési összeg megegyezik a megjelenített árral.",
    "pricing.you_can":"Előfizetéssel megteheti",
    "pricing.up_to":"Képek feltöltése legfeljebb",
    "pricing.upscale_images":"Előkelő képek a",
    "pricing.no_watermark":"nincs vízjel",
    "pricing.enhance":"Növelje",
    "pricing.or_more":"képek vagy több",
    "pricing.in_batch":"kötegben",
    "pricing.enlarge_images":"Képek nagyítása be",
    "pricing.and":"és",
    "pricing.times_with":"alkalommal korlátozás nélkül",
    "pricing.enjoy":"Élvezd",
    "pricing.of_history":"a történelem tárolási ideje",
    "pricing.experience":"Tapasztalat",
    "pricing.fast_upscaling":"gyors felskálázás",
    "pricing.higher_priority":"magasabb prioritású",
    "pricing.early_access":"Korai hozzáférés az új funkciókhoz",
    "pricing.cancel_anytime":"Bármikor lemondhatja",
    "pricing.lifetime_license":"Élettartamra szóló licenccel megteheti",
    "pricing.and_there":"És lesz is",
    "pricing.no_expiration":"nincs lejárati idő",
    "pricing.unless":"hacsak ki nem fogy az összes előkelő",

    "buynow.pop.credit":"hitel",
    "buynow.pop.credits":"krediteket",

    "isUnderequityTip_msg1":"{%} képet választott ki kötegelt feldolgozásra, és nincs elég előny, még mindig {%} jóváírásra van szüksége (jelenleg {%} jóváírás van hátra). Ha feldolgoznia kell, a folytatáshoz vásároljon előnyöket a képek feldolgozását.",
    "isUnderequityTip_msg2":"{%} képet választott ki kötegelt feldolgozásra, és nincs elég hátralévő előny, még mindig {%} jóváírásra van szüksége (jelenleg {%} kép van hátra az előnyökből). Ha fel kell dolgozni, vásároljon előnyöket hogy folytassa a képek feldolgozását.",
    "isUnderequityTip_msg3":"{%} képet választott ki kötegelt feldolgozásra, és nincs elég előny, még mindig {%} kreditre van szüksége (jelenleg {%} kredit van, {%} kép az előnyökből), ha szüksége van folyamat, kérjük, vásároljon előnyöket a képek feldolgozásának folytatásához.",
    "btn_buy_now":"Vásároljon most",
    "isEquityDepletionTip_msg":"Jelenlegi előnyeit felhasználták. Kérjük, vásárolja meg a kötegelt feldolgozás előnyeit.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Csomagok és Árak",
    "pricing.banner_content":"Szerezzen AI Photo Editor krediteket képhátterek eltávolításához, képek felskálázásához és objektumok eltávolításához a képekből online vagy az asztalról.",
    "pricing.best_seller":"Legjobban Eladott",
    "pricing.monthly":"Havi Előfizetés",
    "pricing.credits":"kredit",
    "pricing.lifetime":"Élettartam",
    "pricing.note":"Megjegyzés",
    "pricing.buy_now":"Vásároljon most",
    "pricing.note_content":"A megvásárolt kreditek a bevásárlókosárban megadott e-mail címhez vannak kötve. Ezen kreditek használatához kérjük, regisztráljon vagy jelentkezzen be ugyanezzel az e-mail címmel.",

    "header.buy_more":"További vásárlás",
    "header.available_credits":"Elérhető kreditek",
    "header.credits":"kredit"
}